import { Fragment, MouseEvent, useCallback, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton, Menu, MenuItem } from '@mui/material';

import { useTopicStore, useTopicWSStore } from '@/dmdrive/topic/components/Topic/TopicStore';
import { TopicUser } from '@/dmdrive/topic/entities/TopicUser';

interface RequestMasterProps {
  isMe: boolean;
  participant: TopicUser;
}

function ParticipantActions(props: RequestMasterProps) {
  const { isMe, participant } = props;
  const { me, isJoinedConference } = useTopicStore();
  const { promoteToMaster, demoteMaster } = useTopicWSStore();

  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);
  const onOpenDropdown = useCallback((event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget), []);
  const onCloseDropdown = useCallback(() => setAnchorEl(null), []);

  const onMakeMaster = useCallback(() => {
    promoteToMaster(participant.urn);
    onCloseDropdown();
  }, [participant.urn]);

  const onDemoteMaster = useCallback(() => {
    demoteMaster();
    onCloseDropdown();
  }, []);

  const menu = useMemo(
    () =>
      [
        !isMe && me?.isMaster && !participant.isMaster && (
          <MenuItem key="promote-master" onClick={onMakeMaster}>
            Make Master
          </MenuItem>
        ),
        !isMe && me?.isOwner && participant.isMaster && (
          <MenuItem key="demote-master" onClick={onDemoteMaster}>
            Withdraw Master Permission
          </MenuItem>
        ),
      ].filter((menuItem) => !!menuItem),
    [isMe, me?.isMaster, participant.isMaster, me?.isOwner, onMakeMaster, onDemoteMaster],
  );

  return (
    <Fragment>
      <IconButton disabled={!isJoinedConference || isMe || menu.length === 0} onClick={onOpenDropdown}>
        <MoreVertIcon />
      </IconButton>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onCloseDropdown}>
        {menu}
      </Menu>
    </Fragment>
  );
}

export default observer(ParticipantActions);
